import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { memberApi } from '../api';
import { useMemberApp } from '../AppProvider';
import { IconClose } from './Icons';

export default function FeedbackModal() {
  const { feedbackOpen, setFeedbackOpen } = useMemberApp();
  const location = useLocation();
  const [body, setBody] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!feedbackOpen) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (body.trim().length < 4 || busy) return;
    setBusy(true);
    try {
      await memberApi.feedback({ body: body.trim(), page: location.pathname });
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="by-modal-back" role="dialog" aria-modal="true">
      <div className="by-modal" style={{ width: 'min(520px, 100%)' }}>
        <button className="by-icon-btn" style={{ position: 'absolute', top: 16, right: 16 }} onClick={() => { setFeedbackOpen(false); setSent(false); setBody(''); }} aria-label="Close">
          <IconClose />
        </button>
        <h2>Share feedback</h2>
        <p className="by-lede">Tell us what is missing, confusing, or wrong. This goes directly to the ByOnco team.</p>
        {sent ? (
          <p>Thank you. We read every note.</p>
        ) : (
          <form onSubmit={submit}>
            <label className="by-field">
              <span>Your note</span>
              <textarea rows={5} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Describe your feedback or the issue you encountered…" />
            </label>
            <div className="by-row">
              <button type="button" className="by-btn by-btn-ghost" onClick={() => setFeedbackOpen(false)}>Cancel</button>
              <button type="submit" className="by-btn by-btn-dark" disabled={busy || body.trim().length < 4}>
                Submit feedback
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
